// frontend/services/syncService.ts

import { fetchUserData, syncUserData, SyncPayload, UserDataResponse } from './apis';

class SyncService {
    private syncInterval: NodeJS.Timeout | null = null;
    private AUTO_SYNC_INTERVAL = 60000; // 1 minute

    // Fetch user data from backend
    async fetchUserData(): Promise<UserDataResponse | null> {
        try {
            return await fetchUserData();
        } catch {
            return null;
        }
    }

    // Sync complete state to backend
    async syncAll(data: SyncPayload): Promise<boolean> {
        try {
            await syncUserData(data);
            return true;
        } catch {
            return false;
        }
    }

    // Start auto-sync
    startAutoSync(getState: () => SyncPayload, isRunning: () => boolean) {
        if (this.syncInterval) return;

        this.syncInterval = setInterval(() => {
            const token = localStorage.getItem('pomozid_token');
            if (!token) {
                this.stopAutoSync();
                return;
            }

            if (!isRunning()) {
                return;
            }

            const state = getState();
            this.syncAll(state);
        }, this.AUTO_SYNC_INTERVAL);

        console.log('🔄 Auto-sync started (every 60s)');
    }

    // Stop auto-sync
    stopAutoSync() {
        if (this.syncInterval) {
            clearInterval(this.syncInterval);
            this.syncInterval = null;
            console.log('⏸️ Auto-sync stopped');
        }
    }
}

export const syncService = new SyncService();